import { parse, stringify } from 'uuid'
import * as Base64Url from './base64Url'

// Encodes UUIDs into a 22-character URL-safe base64 slug representation (see RFC 4648 sec. 5)
export function encode(uuidString: string): string {
  const buffer = parse(uuidString)
  const bytes = new Uint8Array(buffer)

  const binary = bytes.reduce(
    (binary, byte) => (binary += String.fromCharCode(byte)),
    ''
  )

  return Base64Url.encode(binary)
}

// Decode the slug id into a UUID representation
export function decode(uuidSlug: string): string {
  const byteCharacters = Base64Url.decode(uuidSlug)
  const byteNumbers = byteCharacters.split('').map((char) => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)

  return stringify(byteArray)
}
